// extracted by mini-css-extract-plugin
export var csatScore = "_ew-5";
export var header = "_ew-1";
export var panelWrapper = "_ew-2";
export var postPreview = "_ew-3";
export var rightContent = "_ew-0";
export var wrappingText = "_ew-4";